
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuService } from '../../../../services/menu.service';
import { TranslationService } from '../../../../services/translation.service';
import { TimeFrame, TimeFrameManager, Helper, MenuNode } from '../../../../classes';
@Component({
  selector: 'app-zeitwahl',
  templateUrl: './zeitwahl.component.html',
  styleUrls: ['./zeitwahl.component.scss']
})
export class ZeitwahlComponent implements OnInit {
	_debug:boolean = false;
	title:string;
	subtitle:string;

    pans=0;
    panSkip=3;

	createDate(hour,minute){
		let date = new Date();
		if(minute == 60){
			date.setHours(hour+1);	
			date.setMinutes(0);
		}else{
			date.setHours(hour);
			date.setMinutes(minute);
		}
		return date;
	}
	virtualFrame : TimeFrame;
	getBackground(hour,minute){





		let date = this.createDate(hour,minute);
		
		if(this.stage == "start_time"){
			
			let fm = this.frameManager.getTimeFrame(this.targetDays[0],date);
			if(fm == null){
				return 'black';
			}
			if(fm.getId() == this.virtualFrame.getId()){
				return 'black';
			}else{
				return 'grey';
			}
		
		}else{
			if(this.virtualFrame.contains(date)){
				return 'white';
			}
			let fm = this.frameManager.getTimeFrame(this.targetDays[0],date);
			if(fm == null){
				return 'black';
			}
			if(fm.getId() != this.virtualFrame.getId()){
				return 'grey';
			}
		}



		/*
		let date = this.createDate(hour,minute);
		if(this.stage == "start_time"){
			if(this.frameManager.getTimeFrames(this.targetDays[0]).length == 0){
				return 'black';
			}else{
				if(this.frameManager.getTimeFrame(this.targetDays[0],date)){
					return 'grey';
				}
			}
		}else{
			if(this.virtualFrame.contains(date)){
				return 'white';
			}else{
				let fm = this.frameManager.getTimeFrame(this.targetDays[0],date);
				if(fm == null){
					return 'black';
				}
				if(fm.getId() == this.virtualFrame.getId()){
					return 'white';
				}else{
					return 'grey';
				}
			}
		}
		*/


	}
	debug(msg:string){
		if(this._debug){
			console.log("ZeitwahlComponent: "+msg);
		}
	}
	
	timeframe:TimeFrame;
	currentTime : Date;
	
	currentTimeFrame : TimeFrame;
	zone:string;
	day:number;
	mode:string;
	id:number;
	stage:string;
	hours : Array<number>;
	left="-15%";
	_left=15;
	timeframes : Array<TimeFrame>;
	conflict=false;
	frameManager:TimeFrameManager


	eventSubscription:any;
	frameManagerParent : any;
	targetDays:Array<number>;
	node: MenuNode;


	constructor(private menuService: MenuService, private ioService: DataIoService,private translator: TranslationService) {
		this.debug("constructing DayPlannerComponent.");
		this.hours = new Array<number>();
		for(let i=0;i<24;i++){
			this.hours.push(i);
		}
		this._left = 15;
		this.left = this._left+"%";
		this.debug("constructed.");
	}

	eventHandler(event){
		this.debug("Event:"+event);
		switch(event){
			case 'panup':{

			}
			case 'up':{
				let newCurrentTime = new Date(this.currentTime.getTime()+(10*60*1000));
				if(newCurrentTime.getDate() != this.currentTime.getDate()){
					/*
					this.currentTime.setMinutes(59);
					this.currentTime.setSeconds(59);
					this.currentTime.setMilliseconds(0);
					*/
				}else{
					this.currentTime = newCurrentTime;
				}
				
				break;
			}
			case 'pandown':{
				
			}
			case 'down':{
				this.debug("decreasing time.");
				let newCurrentTime = new Date(this.currentTime.getTime()-(10*60*1000));
				if(newCurrentTime.getMinutes() == 49){
					newCurrentTime.setMinutes(50);
					newCurrentTime.setSeconds(0);
					newCurrentTime.setMilliseconds(0);
				}
				if(newCurrentTime.getDate() != this.currentTime.getDate()){
					break;
				}
				if(this.stage == "end_time"){
					if(newCurrentTime.getTime() <= this.virtualFrame.getBegin().getTime()){
						break;
					}
				}
				this.currentTime = new Date(newCurrentTime);
				break;
			}
			case 'back':{
				this.ioService.setCurrentTimeFrame(null);
				if(this.menuService.getCurrentNode().hasBackTarget()){
					let backTarget = this.menuService.getCurrentNode().getBackTargetNode();
					this.menuService.goto(backTarget);
					return;
				}
				this.menuService.historyBack();
				return;
			}
			case 'confirm':{
				if(this.mode == "add"){
					let frameCopy = new TimeFrame();
					frameCopy.copy(this.timeframe);

					for(let day of this.targetDays){
						this.debug("Changing day of "+frameCopy.getId() + " from "+frameCopy.getDay() +  " to " + day);
						frameCopy.setDay(day);
						if(this.stage == 'start_time'){
							frameCopy.setBegin(this.currentTime);
						}
						if(this.stage == 'end_time'){
							frameCopy.setEnd(this.currentTime);
						}
						this.debug("adding timeframe "+frameCopy.toString(true) +" to day "+day);
						this.frameManager.addTimeFrame(frameCopy);
						
					}
					this.debug(this.frameManager.toString());
				}
				if(this.mode == "edit"){
					for(let day of this.targetDays){
						//this.timeframe.setDay(day);
						if(this.stage == 'start_time'){
							this.debug("EDIT start-time on most recent element " + this.frameManager.getMostRecentFrame(day).toString(true)+" on day "+day);
							this.frameManager.getMostRecentFrame(day).setBegin(this.currentTime);
						}
						if(this.stage == 'end_time'){
							this.debug("EDIT end-time on most recent element " + this.frameManager.getMostRecentFrame(day).toString(true)+" on day "+day);
							this.frameManager.getMostRecentFrame(day).setEnd(this.currentTime);
						}
						
					}
					this.debug(this.frameManager.toString());
				}

				let target:MenuNode = this.node.getTargetNode();
				if(target){
					this.menuService.goto(target);
					return;
				}else{
					this.debug("target was null. returning.");
				}
				return;
			}
		}
		if(this.stage == 'start_time'){
			this.virtualFrame.setBegin(this.currentTime);
		}else{
			this.virtualFrame.setEnd(this.currentTime);
		}

		this.conflict = this.hasConflict();
		this.adjustSlider();
	}
	adjustSlider(){

		let currentPercentage = (this.currentTime.getHours()+(this.currentTime.getMinutes()/60))/24.0;
		if(this.stage == 'start_time'){
			this._left = 15;
		}else{
			this._left = 79;
		}
		let hourWidth = 10.3;
		let hourGap=1;
		let hourCombined = hourWidth+hourGap;
			
		this._left -= (this.currentTime.getHours()*(hourWidth+hourGap))+(this.currentTime.getMinutes()/60.0)*hourWidth;
		
		this.left=this._left+"%";
	}
	hasConflict(){


		let timeFrame = (this.frameManager.getTimeFrame(this.targetDays[0],this.currentTime));
		if(this.stage == 'start_time'){
			if(!timeFrame){
				this.conflict = false;
				return false;
				
			}
			if(timeFrame.getId() == this.virtualFrame.getId()){
				this.conflict = false;
				return false;
			}
			if(timeFrame.toNumber(timeFrame.getEnd()) == timeFrame.toNumber(this.currentTime)){
				this.conflict = false;
				return false;
			}
			return true;
		}
		if(this.stage == "end_time"){
			for(let fm of this.frameManager.getTimeFrames(this.targetDays[0])){
				if(fm.getId() != this.virtualFrame.getId() && fm.overlapsWith(this.virtualFrame)){
					this.debug("Overlapping: "+this.virtualFrame.toString() + " and "+ fm.toString());
					this.conflict=true;
					return true;				
				}
			}
			this.conflict = false;
			return false;
		}
		

		/*
		let timeFrame = (this.frameManager.getTimeFrame(this.targetDays[0],this.currentTime));
		if(!timeFrame){
			this.conflict = false;
			return false;
		}
		if(timeFrame.getId() == this.timeframe.getId()){
			this.conflict = false;
			return false;
		}
		return true;
		*/
	}

	/**

		Wertet die Parameter entsprechend der übergebenen menüstruktur aus.

		beispiel: value: zeitprogrammassistent.clearadd.weekdays.begin.09,00
		0: zeitprogrammassistent|etc. : adressiert den TimeFrameManager
		1: (edit|add|clearadd): neuen wert hinzufügen, editieren oder manager leeren und hinzufügen
		2: (int|weekdays|weekend) adressiert die veränderten tage 
		3: (begin|end) anfang oder ende der periode setzen.
		5: (hours,minutes) ausgangs-uhrzeits
	**/
	evaluateNodeValue(){
		if(this.node.getValue()){
			let valueParts = Helper.split(this.node.getValue(),'.');

			switch(valueParts[1]){
				case 'clearadd':{

					this.mode = 'add';
					this.timeframe = new TimeFrame();
					this.debug("Mode: clearadd");
					break;
				}
				case 'add':{
					this.mode = 'add';
					this.timeframe = new TimeFrame();
					this.debug("Mode: add");
					break;
				}
				case 'edit':{
					this.mode = 'edit';
					this.debug("Mode: edit");
					break;
				}
				default:{
					this.debug("defaulting while setting mode.");
					break;
				}
			}
			switch(valueParts[0]){
				case 'zeitprogrammassistent':{
					this.frameManagerParent = this.ioService.getZeitprogrammAssistent();
					this.frameManager = this.frameManagerParent.getFrameManager();
					this.debug("frameManagerParent: Zeitprogrammassistent");
					if(this.timeframe){
						this.timeframe.setValue(this.ioService.getZeitprogrammAssistent().getScale('wunschtemperatur').getCurrentValue());
					}

					break;
				}
				default:{
					break;
				}
			}
			this.targetDays = new Array<number>();
			switch(valueParts[2]){
				case '0':
				case '1':
				case '2':
				case '3':
				case '4':
				case '5':
				case '6':{
					this.targetDays.push(parseInt(valueParts[2]));
					this.debug("setting target-days to:"+JSON.stringify(this.targetDays));
					break;
				}
				case 'weekdays':{
					for(let i=0;i<5;i++){
						this.targetDays.push(i);
					}
					break;
				}
				case 'weekend':{
					for(let i=5;i<7;i++){
						this.targetDays.push(i);
					}
					break;
				}
				default:{
					this.debug("Not setting targetdays. Cannot parse ["+valueParts[2]+"]");
					return;
				}
			}


			switch(valueParts[3]){
				case 'begin':{
					this.stage = 'start_time';

					break;
				}
				case 'end':{
					this.stage = 'end_time';
				}
			}
			if(this.mode == 'edit'){
				this.timeframe = this.frameManager.getMostRecentFrame(this.targetDays[0]);
				this.debug("Found timeframes: ");
				for(let tf of this.frameManager.getTimeFrames(this.targetDays[0])){
					this.debug(tf.toString(true));
				}
				this.debug("Loaded frame:" +this.timeframe);
			}else{
				this.timeframe = this.frameManager.getMostRecentFrame(this.targetDays[0]);
				if(!this.timeframe){
					this.timeframe = new TimeFrame();
				}
			}
			
			this.virtualFrame = new TimeFrame();
			this.virtualFrame.copy(this.timeframe);
			this.virtualFrame.setId(this.timeframe.getId());
			
			if(valueParts.length >= 4 && valueParts[4]){
				let hours=parseInt(valueParts[4].split(',')[0]);
				let minutes=parseInt(valueParts[4].split(',')[1])
				this.debug("Setting hours/minutes to:"+hours+":"+minutes);
				this.currentTime.setHours(hours);
				this.currentTime.setMinutes(minutes);
			}else{
				this.debug("No default time in value:" +this.node.getValue());
			}


			this.debug("setting target-days to:"+JSON.stringify(this.targetDays));
			
			if(valueParts[1]=="clearadd"){
				for(let day of this.targetDays){
					this.debug("clearing timeframes of day "+day);
					this.frameManager.clearDay(day);					
				}
			}
			this.timeframes = this.frameManager.getTimeFrames(this.targetDays[0]);
			if(this.mode == "start_time"){
				this.virtualFrame.setBegin(this.currentTime);
			}else{
				this.virtualFrame.setEnd(this.currentTime);
			}
		}else{
			this.debug("Error: no node-value");
		}

	}
	ngOnInit() {
		this.currentTime = new Date();
		this.node = this.menuService.getCurrentNode();
		this.evaluateNodeValue();
		this.title = this.node.getTitle();
		this.adjustSlider();
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
			(event)=>{
				this.eventHandler(event);				
			}
		);




	}
	getText(idx:number):string{
		return this.node.getText(idx);
	}
	ngOnDestroy(){
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
	}

}
